try {
    require("website_design_system");
} catch (e) {}

require("index.css");
